// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__17Mkz","topBottomGutter":"Layout_topBottomGutter__2xzP1"};